export default "__VITE_ASSET__BSUbCXoc__"